import packageInfo from "../../package.json";

export const environment = {
  appVersion: packageInfo.version,
  production: false,
  // Local backend: ng serve -c local (environment.local.ts).
  API_DOMAIN: "https://back-dev-velo.betacore.pro/api/v1",
  maxRecordingSeconds: 30,
  maxRecordingAttempts: 3,
  SERVICES: {
    LOGIN: `/auth/login`,
    LOGOUT: `/auth/logout`,
    REFRESH: `/auth/refresh`,
    PASSWORD_RECOVERY_REQUEST: `/auth/password-recovery/request`,
    PASSWORD_RECOVERY_VERIFY: `/auth/password-recovery/verify`,
    PASSWORD_RECOVERY_RESET: `/auth/password-recovery/reset`,
    MUNICIPALITIES: `/municipalities`,
    SUPPORT_CHANNELS: `/support-channels`,
    ADMIN_BANNERS: `/admin/banners`,
    ADMIN_BUSINESSES: `/admin/businesses`,
    ADMIN_BUSINESSES_EXPORT: `/admin/businesses/export`,
    ADMIN_TERMS_AND_CONDITIONS: `/admin/terms-and-conditions`,
    TERMS_AND_CONDITIONS: `/terms-and-conditions`,
    ADMIN_PARAMETERS: `/admin/parameters`,
    ADMIN_APP_VERSIONS: `/admin/app-versions`,
    ADMIN_APP_IMAGES: `/admin/app-images`,
    SOCIAL_NETWORKS: `/social-networks`,
    ADMIN_CUSTOMERS: `/admin/customers`,
    ADMIN_CUSTOMERS_EXPORT: `/admin/customers/export`,
    ADMIN_DEPARTMENTS: `/admin/departments`,
    ADMIN_MUNICIPALITIES: `/admin/municipalities`,
    ADMIN_ADMINISTRATORS: `/admin/administrators`,
    ADMIN_DASHBOARD: `/admin/dashboard`,
    ADMIN_DASHBOARD_EXPORT: `/admin/dashboard/export`,
    CATEGORIES: `/categories`,
    QR_CODES: `/qr-codes`,
    QR_BATCHES: `/qr-batches`,
    ORGANIZATIONS: `/organizations`,
    USERS: `/users`,
    HOLIDAY_THEMES: `/holiday-themes`,
    UPLOAD_MEDIA: `/uploads/media`,
  },
};
